module.exports = __webpack_public_path__ + "img/delete_gist_documentation.2dc0ac15.png";